<ng-container *transloco="let t">
  <app-page-template>
    <div class="container">
      <div class="pt-48-38 pb-300-228">
        <app-grey-card-with-title [title]="t('app.common.login')">
          <div class="px-10">
            <form #authFormEdit="ngForm" [formGroup]="inputForm">
              <app-input formControlName="email" label="app.common.user.email"/>
              <div class="pt-20-10">
                <app-input type="password" formControlName="password" label="app.common.password"/>
              </div>
              <div class="pt-16 d-flex justify-content-center cursor-pointer" (click)="goToRecoverPasswordPage()">
                {{ t('app.common.forgot.password') }}
              </div>
              <div class="pt-20-10 mt-30 d-flex justify-content-center pb-16">
                <app-rounded-button [label]="t('app.common.login.button')"
                                    (onClick)="onSubmit()" [isDisabled]="!authFormEdit.valid"/>
              </div>
              <app-section-divider/>
              @if(currentWindowWidth >= 768){
                <div class="d-flex justify-content-center">
                  <div class="social-wrapper">
                    <div class="text-center">
                      <asl-google-signin-button type='standard' size='large' shape="pill" theme="filled_blue"
                                                [width]="googleSigninButton"
                                                [text]="t('signup.continue.with.google')"/>
                    </div>
                    <div class="pt-3 text-center">
                      <app-button [label]="t('signup.continue.with.facebook')" (onClick)="onFacebookLogin()"
                                  [btnClass]="'btn-facebook btn-large social-network-button'">
                        <img src="assets/img/facebook-circle-icon-white.png" alt="" width="36" height="36">
                      </app-button>
                    </div>
                  </div>
                </div>
              }@else {
                <div class="d-flex align-items-center justify-content-center">
                  <div class="pe-3">
                    <asl-google-signin-button type='icon' size='large' shape="pill" theme="filled_blue"
                                              [text]="t('signup.continue.with.google')"/>
                  </div>
                  <div class="link" (click)="onFacebookLogin()">
                    <img src="assets/img/facebook_circle_icon.svg" alt="" width="44" height="44">
                  </div>
                </div>
              }
            </form>
          </div>
        </app-grey-card-with-title>
      </div>
    </div>
    <app-footer />
  </app-page-template>
</ng-container>
